<template>
    <div class="dam-status d-flex align-items-center"
         :class="statusArr[2]">
        <div
            class="status-dot"
            :class="[statusArr[2], {'large-dot': largeDot}]"
        ></div>
        <div
            class="status-text-colorer"
            :class="statusArr[2]"
        >
            <span class="d-block" v-if="!overflowingText">{{ statusArr[1] }}</span>
            <span class="d-block" v-if="overflowingText">{{ overflowingText }}</span>
        </div>
    </div>
</template>

<script>
    import {OVERFLOWING_WATER_LEVEL} from "@/constants/map-constants";

    /**
     * Shows a small dot - green, yellow or red,
     * depending on the status.
     * The status required, consists of: wrapper class,
     * number and text.
     */

    export default {
        name: "StatusDotText",
        props: {
            statusArr: Array,
            largeDot: {
                type: Boolean,
                default: false
            },
            overflowInfo: {
                type: Object,
                default() {
                    return {
                        attribute_text: "",
                        nok_conf: false,
                        overflowing_by_cm: 0,
                        overflowing_flag: false,
                        state: 1
                    };
                }
            }
        },
        computed: {
            overflowingText() {
                if (this.overflowInfo.attribute_text === OVERFLOWING_WATER_LEVEL) {
                    const overflowCm = this.overflowInfo.overflowing_by_cm;
                    return this.$i18n.t('dashboard.infoWindow.overflow-message', {meters: overflowCm})
                } else {
                    if (this.$i18n.te(`sensors.${this.overflowInfo.attribute_text}`)) {
                        return this.$i18n.t(`sensors.${this.overflowInfo.attribute_text}`);
                    } else {
                        return '';
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
    @import "../../assets/scss/mixins";
</style>